import { ComponentType } from 'react';
import { styled } from '../../../theme/styled';
import { Typography, TypographyProps } from '../../typography';
import { AudioPlayerOwnerState } from '../model';

type AudioPlayer = ComponentType<TypographyProps & { ownerState: AudioPlayerOwnerState }>;

export const AudioPlayerDuration = styled(Typography, {
  name: 'AudioPlayer',
  slot: 'Duration',
})<{ ownerState: AudioPlayerOwnerState }>(({ theme, ownerState }) => {
  return {
    ...theme.typography['small text'],
    marginLeft: { normal: 15, small: 8 }[ownerState.size],
  };
}) as unknown as AudioPlayer;
